import React from "react";
import Transactions from "modules/transactions";

const TransactionsPage = () => {
  return <Transactions />;
};

export default TransactionsPage;
